const classNames = (array = []) => {
  const effectiveCssClasses = array.filter(Boolean)
  return effectiveCssClasses.join(' ').trim()
}

export default classNames
